<template>
	<div class="app-container logTab">
		<!-- 数据列表 -->
		<el-table v-loading="loading" element-loading-text="加载中" :data="list">
			<el-table-column label="登录时间" align="center" prop="createTime" />
			<el-table-column label="IP地址" align="center" prop="loginIp" />
			<el-table-column label="地址" align="center" prop="provinceName">
				<template slot-scope="scope">
					{{scope.row.provinceName}}{{scope.row.cityName}}
				</template>
			</el-table-column>

		</el-table>

		<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
			:limit.sync="queryParams.pageSize" @pagination="_getList" />
	</div>
</template>

<script>
	import * as API_Login from "@/api/sportManage/monitor/logininfor";
	export default {
		name: "entryLog",
		props: ["id","name"],
		data() {
			return {
				pageName: '登录日志',
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				loading: false,
			};
		},
		watch: {
			name: {
				handler(newVal, oldVal) {
					if(newVal == 'log') this._getList()
				},
			}
		},
		created() {},
		methods: {
			// 接口-登录日志
			_getList() {
				API_Login.list({
					memberId: this.id
				}).then((res) => {
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
		},
	};
</script>

<style scoped lang="scss">
.logTab {
	padding: 20px 0;
}
</style>